import { Box, Paper, Typography } from '@mui/material';
import { ReactNode } from 'react';

import {
  ruleFormContentStyle,
  ruleFormHeaderStyle,
  ruleStepIndicatorStyle
} from 'styles/pages/ApprovalRuleFormStyle';

interface SectionCardProps {
  readonly number: number;
  readonly title: string;
  readonly action?: ReactNode;
  readonly children: ReactNode;
}

export const SectionCard = ({
  number,
  title,
  action,
  children
}: SectionCardProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '1rem',
        border: '1px solid #e5e7eb'
      }}
    >
      <Box sx={ruleFormHeaderStyle}>
        <Box sx={ruleStepIndicatorStyle}>{number}</Box>
        <Typography
          variant="body1"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600
          }}
        >
          {title}
        </Typography>
        {action && <Box sx={{ marginLeft: 'auto' }}>{action}</Box>}
      </Box>
      <Box sx={ruleFormContentStyle}>{children}</Box>
    </Paper>
  );
};
